@if (viewModel) {
    @let state = viewModel.state$ | async;
    @let tooltip = viewModel.tooltip$ | async;
    @let blockedReason = viewModel.blockedReason$ | async;

    @if (state !== DisplayState.Hidden && state !== null) {
        <!-- O botão de fixar é irmão do <a>, não filho: botão dentro de link é HTML
             inválido e faz o leitor de tela anunciar um controle dentro do outro. -->
        <div class="linha">
        <a mat-list-item
            #rla="routerLinkActive"
            [activated]="rla.isActive || isSubmenuActive(viewModel)"
            [class.locked]="isLocked(state)"
            [class.blocked]="!!blockedReason"
            [routerLink]="rotaDe(viewModel, state, blockedReason)"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive
            [appTooltip]="tooltip ?? ''"
            [matMenuTriggerFor]="hasFlyout(state) ? flyout : null"
            (click)="handleMainClick(viewModel, state, blockedReason)">
            <span matListItemIcon [innerHTML]="viewModel.icon"></span>
            <span matListItemTitle>{{ viewModel.title }}</span>

            <!-- SVG e não mat-icon: a fonte de ícone depende de ligadura, que qualquer
                 letter-spacing ou troca de família herdada quebra, e aí aparece o nome
                 escrito na tela. Aqui o desenho não depende de fonte nenhuma. -->
            @if (state === DisplayState.Submenu) {
                <span matListItemMeta class="seta" [@rotateArrow]="expanded() ? 'expanded' : 'collapsed'">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                </span>
            } @else if (isLocked(state)) {
                <span matListItemMeta class="cadeado">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                    </svg>
                </span>
            }
        </a>

        @if (podeFavoritar(viewModel, state)) {
            <button type="button" class="fixar"
                [class.fixado]="favoritos.estaFavoritado(viewModel.original)"
                [attr.aria-pressed]="favoritos.estaFavoritado(viewModel.original)"
                [attr.aria-label]="(favoritos.estaFavoritado(viewModel.original) ? 'Desafixar ' : 'Fixar ') + viewModel.title"
                (click)="alternarFavorito(viewModel)">
                <!-- SVG e não mat-icon, pelo mesmo motivo da seta e do cadeado. -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    [attr.fill]="favoritos.estaFavoritado(viewModel.original) ? 'currentColor' : 'none'">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                </svg>
            </button>
        }
        </div>
    }
}

<!-- Menu recolhido: os subitens saem num flyout ao lado do ícone, já que não há onde
     abri-los na faixa. O matMenuContent mantém a montagem preguiçosa — nada aqui existe
     antes do primeiro clique. O #flyout precisa ficar fora de @if para o gatilho o ver. -->
<mat-menu #flyout xPosition="after" yPosition="below">
    <ng-template matMenuContent>
        @if (viewModel) {
            <div class="flyout-title">{{ viewModel.title }}</div>

            @for (subVm of viewModel.submenu; track $index) {
                @let subState = subVm.state$ | async;
                @let subTooltip = subVm.tooltip$ | async;
                @let subBlockedReason = subVm.blockedReason$ | async;

                @if (subState !== DisplayState.Hidden && subState !== null) {
                    <a mat-menu-item
                        [class.locked]="isLocked(subState)"
                        [class.blocked]="!!subBlockedReason"
                        [routerLink]="rotaDe(subVm, subState, subBlockedReason)"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLinkActive="flyout-active"
                        [appTooltip]="subTooltip ?? ''"
                        (click)="handleSubmenuClick(subVm, subState, subBlockedReason)">
                        <span>{{ subVm.title }}</span>

                        @if (isLocked(subState)) {
                            <mat-icon iconPositionEnd>lock</mat-icon>
                        }
                    </a>
                }
            }
        }
    </ng-template>
</mat-menu>

@if (viewModel && viewModel.submenu && expanded() && !collapsed()) {
    <mat-nav-list @fadeSlideInOut class="submenu">
        @for (subVm of viewModel.submenu; track $index) {
            @let subState = subVm.state$ | async;
            @let subTooltip = subVm.tooltip$ | async;
            @let subBlockedReason = subVm.blockedReason$ | async;

            @if (subState !== DisplayState.Hidden && subState !== null) {
                <div class="linha">
                <a mat-list-item
                    #subRla="routerLinkActive"
                    [activated]="subRla.isActive"
                    [class.locked]="isLocked(subState)"
                    [class.blocked]="!!subBlockedReason"
                    [routerLink]="rotaDe(subVm, subState, subBlockedReason)"
                    [routerLinkActiveOptions]="{ exact: true }"
                    routerLinkActive
                    [appTooltip]="subTooltip ?? ''"
                    (click)="handleSubmenuClick(subVm, subState, subBlockedReason)">
                    <span matListItemTitle>{{ subVm.title }}</span>

                    @if (isLocked(subState)) {
                        <span matListItemMeta class="cadeado">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                            </svg>
                        </span>
                    }
                </a>

                @if (podeFavoritar(subVm, subState)) {
                    <button type="button" class="fixar"
                        [class.fixado]="favoritos.estaFavoritado(subVm.original)"
                        [attr.aria-pressed]="favoritos.estaFavoritado(subVm.original)"
                        [attr.aria-label]="(favoritos.estaFavoritado(subVm.original) ? 'Desafixar ' : 'Fixar ') + subVm.title"
                        (click)="alternarFavorito(subVm)">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                            [attr.fill]="favoritos.estaFavoritado(subVm.original) ? 'currentColor' : 'none'">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                        </svg>
                    </button>
                }
                </div>
            }
        }
    </mat-nav-list>
}
